import React, { useState, useEffect } from "react";
import SearchIcon from '@mui/icons-material/SearchTwoTone';
import { InputGroup, Button, Col } from "react-bootstrap";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import DataGridPromoCategoryAgent from "./DataGridFiles";
import ApiFilesService from "../../../core/api/Api.filesService";
import { tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl"


const Index = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const [refresh, setRefresh] = useState(false);
  const { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiFilesService.getAll({ pageSize: pageSizeFromUrl, pageNumber: pageNumberFromUrl });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, [refresh]);
  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);

  }
  const onSubmit =
    async (data) => {

      const apiData = await ApiFilesService.getAll({
        pageSize: data.pageSize, pageNumber: getValues("pageNumber"),
        globalSearch: data.globalSearch
      });
      setListData(apiData);
      setValue("totalCount", apiData.totalCount);
      tools.setPageNumber(data, searchParams, setValue);
      var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
      navigate(`/files?${queryString}`);
    }

  return (

    <div>

      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              مدیریت فایل ها
                        </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست فایل های آپلود شده
                        </span>
          </h3>
          <div className="card-toolbar">
            {/* <UploadFiles showText={"آپلود فایل"}  basketItemId={15} ></UploadFiles>  */}
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods} >
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              <div className='border-top pt-3'>
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder='جستجو ...'
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs='12' className='tb-reponsive px-0'>
                {<DataGridPromoCategoryAgent data={listData} callBack={callBackJustForRunUseEffect} />}
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>

  );
};

export default Index;

